import { render, staticRenderFns } from "./ProjectSummaryDraft.vue?vue&type=template&id=0b538105&"
import script from "./ProjectSummaryDraft.vue?vue&type=script&lang=js&"
export * from "./ProjectSummaryDraft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports